import type { ShopperAiIntegrationType } from "../integration/integration";
import type { MessageChannel } from "./message";

export const integrationTypeToChannel = {
  gmail: "email",
  outlook: "email",
  instagram: "instagram",
  facebook: "facebook",
  tiktok: "tiktok",
  attentive: "attentive",
  postscript: "postscript",
} as const satisfies Record<ShopperAiIntegrationType, MessageChannel>;
